import React from'react'

import * as css from '../../FondosAsignados.css'

export class DetalleTotales extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            fondoPendiente: 0
        }
    }
    render() {
        return (
            <div className={"panel panel-info "+css.panelTotales}>
                <div className={"panel-heading "+css.panelHeadingDetalle}>
                    <b>Total Fondo Asignado</b>
                </div>
                <div className={"panel-body "+css.panelBodyTotales}>
                    <div className="col-md-7">
                        <label>Viaticos</label>
                    </div>
                    <div className="col-md-5">
                        <label>{this.props.totales.viaticosLiquidacion.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                    </div>
                    <div className="col-md-7">
                        <label>A Rendir</label>
                    </div>
                    <div className="col-md-5">
                        <label>{this.props.totales.fondosRendir.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                    </div>
                    <div className="col-md-7">
                        <label>Mi Saldo</label>
                    </div>
                    <div className="col-md-5">
                        <label>{this.props.totales.fondoPendiente.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                    </div>
                    <div className="col-md-7">
                        <label>Total Depósito</label>
                    </div>
                    <div className="col-md-5">
                        <label>{this.props.totales.fondoGirar.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/totales/DetalleTotales.jsx